import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'loyaltic-profile-orders',
  templateUrl: './profile-orders.component.html',
  styleUrls: ['./profile-orders.component.scss']
})
export class ProfileOrdersComponent implements OnInit {
  @Input() employeeorder: [];
  constructor() { }

  ngOnInit() {
    
  }

  getOrderStatusType(order: any): 'approved' | 'pending' | 'rejected' {
    const status = order && order.status ? order.status.toString().toLowerCase() : '';

    if (status.indexOf('reject') > -1 || status.indexOf('declin') > -1 ||
      status.indexOf('notapproved') > -1 || status.indexOf('not approved') > -1 || status.indexOf('avvis') > -1) {
      return 'rejected';
    }

    if (status.indexOf('pending') > -1 || status.indexOf('vänt') > -1 || status.indexOf('vant') > -1) {
      return 'pending';
    }

    return 'approved';
  }

  toLowerCase(value: any) {
    return value ? value.toString().toLowerCase() : '';
  }

}
